import React, { useState, forwardRef, useImperativeHandle } from 'react';
import '../../styles/projects/projects.css';
import wp4 from '../../assets/img/wp4.png';
import { ReactComponent as ExperimentIcon } from '../../assets/svg/experiment.svg';



const WP4 = forwardRef((props, ref) => {
	const [isExpanded, setIsExpanded] = useState(false);

	const sectionRef = React.useRef(null);

	const toggleExpand = () => {
		setIsExpanded(!isExpanded);
	};

	useImperativeHandle(ref, () => ({
		expandSection() {
			if (sectionRef.current) {
				const yOffset = -100; 
				const y = sectionRef.current.getBoundingClientRect().top + window.pageYOffset + yOffset;
				window.scrollTo({ top: y, behavior: 'smooth' });
				setTimeout(() => {
					setIsExpanded(true);
				}, 430); 
			}
		},
	}));

	const leaders = [
		{ name: 'Haris Babacic (KI)', link: 'https://ki.se/personer/haris-babacic' },
		{ name: 'Lukas Orre (KI)', link: 'https://ki.se/personer/lukas-orre' },
		{ name: 'Maria Planck (Skåne Univ sjukhus)', link: 'https://www.lu.se/lucat/user/849eb7fe92c1ca1ad15ecdc71512e6ca' },
		{ name: 'Edvard Abel (Salgrenska)', link: null },
		{ name: 'Johan Staaf (LU)', link: 'https://www.lunduniversity.lu.se/lucat/user/840e080acb6ea27da41e22cb0c35f360' },
		{ name: 'Henrik Johansson (KI)', link: 'https://ki.se/personer/henrik-johansson' },
		{ name: 'Simon Ekman (Karolinska Univ. Sjukhuset)', link: 'https://ki.se/personer/simon-ekman' },
		{ name: 'Theo Foukakis (Karolinska Univ. Sjukhuset)', link: 'https://ki.se/en/people/theodoros-foukakis' },
		{ name: 'Johannes Fuchs (GU)', link: 'https://www.gu.se/om-universitetet/hitta-person/johannesfuchs' },
		{ name: 'Mikael Björnstedt (Karolinska Univ. Sjukhuset)', link: 'https://ki.se/personer/mikael-bjornstedt' },
	];

	const [lead, ...participants] = leaders;
	const renderPerson = (person, key) =>
		person.link ? (
			<a key={key} href={person.link} target="_blank" rel="noopener noreferrer">
				{person.name}
			</a>
		) : (
			<span key={key}>{person.name}</span>
		);

	return (
		<section className="WPinfo" ref={sectionRef}>
			<span className='wpinfo-icon'>
				<ExperimentIcon />
			</span>
			<span className="WPinfo-body">
				<h2>Work package 4: Proof of concept clinical cancer proteomics study</h2>
				<p>
					<strong>Led by:</strong>{' '}
					{renderPerson(lead, 'lead')}
				</p>

				{participants.length > 0 && (
					<p>
						<strong>Participants:</strong>{' '}
						{participants.map((p, i) => (
						<React.Fragment key={i}>
							{renderPerson(p, i)}
							{i < participants.length - 1 && ', '}
						</React.Fragment>
						))}
						.
					</p>
				)}
				<div className={`expandable-content ${isExpanded ? 'expanded' : 'collapsed'}`}>
					WP4 is dedicated to testing the real-world application of clinical proteomics through prospective cancer studies. 
					Pilot cohorts in lung and breast cancer are defined to evaluate feasibility, refine protocols, and benchmark workflows 
					developed in earlier WPs. Pre-pilot analyses on retrospective samples provide a foundation for prospective trials, where 
					300 patients will be included across cancer subtypes. Importantly, this work is closely integrated with national cancer 
					precision medicine trials, ensuring that the proteomics analyses are embedded within established clinical frameworks. 
					Together, these efforts will validate the robustness, scalability, and clinical relevance of proteomics in oncology.
					<a href={wp4} target="_blank" rel="noopener noreferrer">
						<img
							src={wp4}
							alt="ProMS Infographic"
							className="projectPlanImg"
						/>
					</a>
				</div>
				<button className="read-more-btn" onClick={toggleExpand}>
					{isExpanded ? 'Show Less' : 'Read More'}
				</button>
			</span>
		</section>
	);
});

export default WP4;
